import { ModalProps } from '../types/ModalTypes';

export interface ContextProps {
  restApiUrl: string | null;
  companionEndpoint: string | null;
  websocketUrl?: string | null;
  googleDriveClientId: string | null;
  googleDriveApiKey: string | null;
  googleDriveAppId: string | null;
  isLoading: boolean;
  productFruitsNewCaseSurveyId?: string | null;
  modalData?: ModalProps;
}

export const context: ContextProps = {
  restApiUrl: null,
  companionEndpoint: null,
  websocketUrl: null,
  isLoading: false,
  googleDriveClientId: null,
  googleDriveApiKey: null,
  googleDriveAppId: null,
  productFruitsNewCaseSurveyId: null,
  modalData: {
    open: false,
    type: 'delete',
  },
};
